import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateCategoriesSlice } from "../store/slices/categoriesSlice";
import { GetCategories } from "../services/NewAuthService";

export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const dispatch = useDispatch();

  const getCategories = async () => {
    const categoriesData = await GetCategories();
    setCategories(categoriesData?.data?.data || []);
    dispatch(updateCategoriesSlice(categoriesData?.data?.data));
  };

  useEffect(() => {
    getCategories();
  }, []);

  return categories;
};
